import { createFileRoute } from '@tanstack/react-router'
import { AdminMenuManagement } from '@/components/admin/AdminMenuManagement'
import { parseMenuSearch, type MenuSearch } from '@/components/admin/menuRouteSearch'

export const Route = createFileRoute('/admin/menu')({
  // The active tab and the costing drill-in live in the URL (F-FE-N157), so
  // "edit this item's recipe" is a link: /admin/menu?tab=costing&item=<id>.
  validateSearch: (search: Record<string, unknown>): MenuSearch => parseMenuSearch(search),
  component: () => <AdminMenuManagement />,
})
